export const HandPointingUpIcon = ({
  color = 'currentColor',
  size = 22,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 22"
      fill="none"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path d="M16 14.9995L16.87 3.2645C16.9172 2.71538 16.7469 2.16969 16.3957 1.74494C16.0444 1.3202 15.5405 1.05039 14.9923 0.993611C14.4441 0.936836 13.8955 1.09764 13.4647 1.4414C13.0339 1.78516 12.7553 2.28436 12.689 2.8315L12 7.9995M1 14.9995V10.9995C1 10.4691 1.21071 9.96036 1.58579 9.58528C1.96086 9.21021 2.46957 8.9995 3 8.9995C3.53043 8.9995 4.03914 9.21021 4.41421 9.58528C4.78929 9.96036 5 10.4691 5 10.9995V13.9995V10.4995C5 9.96906 5.21071 9.46036 5.58579 9.08528C5.96086 8.71021 6.46957 8.4995 7 8.4995C7.53043 8.4995 8.03914 8.71021 8.41421 9.08528C8.78929 9.46036 9 9.96906 9 10.4995V11.9995" />
      <path d="M13 12V10C13 9.46957 12.7893 8.96086 12.4142 8.58579C12.0391 8.21071 11.5304 8 11 8C10.4696 8 9.96086 8.21071 9.58579 8.58579C9.21071 8.96086 9 9.46957 9 10V12" />
      <path d="M16 15C15.464 19 12.642 21 8.5 21C4.358 21 1 19 1 15" />
      <path d="M10.692 16H8C7.46957 16 6.96086 15.7893 6.58579 15.4142C6.21071 15.0391 6 14.5304 6 14C6 13.4696 6.21071 12.9609 6.58579 12.5858C6.96086 12.2107 7.46957 12 8 12H12C14.21 12 16.5 14 15.5 17" />
    </svg>
  )
}
